import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useRef } from 'react';
import '../../App.css';
import '../../css/bootstrap.scss';
import lock from "../../images/lock.png";
import { Link } from 'react-router-dom';
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import { useNavigate } from 'react-router-dom';
import BackButton from '../Includes/BackButton';
import { useTranslation } from 'react-i18next';

function SecurityVerification() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const num1: any = useRef(null);
    const num2: any = useRef(null);
    const num3: any = useRef(null);
    const num4: any = useRef(null);
    const num5: any = useRef(null);
    const num6: any = useRef(null);

    const handleOtp1Change = (value: any) => { num2.current.focus(); };
    const handleOtp2Change = (value: any) => { num3.current.focus(); };
    const handleOtp3Change = (value: any) => { num4.current.focus(); };
    const handleOtp4Change = (value: any) => { num5.current.focus(); };
    const handleOtp5Change = (value: any) => { num6.current.focus(); };
    const handleOtp6Change = (value: any) => { };

    return (
        <>
            <Header />
            <Container fluid className='min-vh-custom'>
                <Row className=''>
                    <Col md={3} className='text-center ms-2'>
                        <div className='mt-5 py-4'>
                            <BackButton />
                        </div>
                    </Col>
                </Row>
                <Row className='mt-5'>
                    <Col md={12} className='text-center'>
                        <img src={lock} width={70} />
                        <h3 className='text-center mt-3'>{t('login.security_title')}</h3>
                        <p className='text-secondary'>{t('login.security_desc')}</p>
                        <p className='mt-3 letter-spacing-fix text-black fw-medium mb-0'>{t('login.enter_code')}</p>
                        <span className='text-secondary'>
                            {t('login.code_sent_to')} &nbsp; <span className='fw-bold text-black'>samran_habib@gmail.com</span>
                        </span>

                        <div className="input-group d-flex justify-content-center mt-3 mb-3">
                            <input type="number" pattern="[0-9]{1}" onChange={(e) => handleOtp1Change(e.target.value)} ref={num1} className='rounded-4 border border-1 otp-input' />
                            <input type="number" pattern="[0-9]{1}" onChange={(e) => handleOtp2Change(e.target.value)} ref={num2} className='ms-2 rounded-4 border border-1 otp-input' maxLength={1} />
                            <input type="number" pattern="[0-9]{1}" onChange={(e) => handleOtp3Change(e.target.value)} ref={num3} className='ms-2 rounded-4 border border-1 otp-input' maxLength={1} />
                            <input type="number" pattern="[0-9]{1}" onChange={(e) => handleOtp4Change(e.target.value)} ref={num4} className='ms-2 rounded-4 border border-1 otp-input' maxLength={1} />
                            <input type="number" pattern="[0-9]{1}" onChange={(e) => handleOtp5Change(e.target.value)} ref={num5} className='ms-2 rounded-4 border border-1 otp-input' maxLength={1} />
                            <input type="number" pattern="[0-9]{1}" onChange={(e) => handleOtp6Change(e.target.value)} ref={num6} className='ms-2 rounded-4 border border-1 otp-input' maxLength={1} />
                        </div>
                        <Link className='text-primary mt-2' to={''}>{t('login.another_method')}</Link>
                        <Row className='justify-content-center'>
                            <Col md={3}>
                                <Row className='m-0 d-flex align-items-center py-4 text-center'>
                                    <Button type="submit" variant='' className="btn rounded-5 border-0 text-white" style={{ background: '#0B1628' }} onClick={() => { navigate('/') }}>{t('common.submit')}</Button>
                                </Row>
                            </Col>
                        </Row>
                        <div className=''>
                            <Link className='text-primary' to={""}>{t('login.switch_method')}</Link>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Footer full={true} />
        </>
    );
}

export default SecurityVerification;
